import type { ReactNode } from 'react'

interface SearchBarProps {
  value: string
  onChange: (value: string) => void
  placeholder?: string
  /** Something inside the box at its right end -- the Miro panel's tag menu. */
  trailing?: ReactNode
}

export function SearchBar({ value, onChange, placeholder = 'Search the audit library…', trailing }: SearchBarProps) {
  return (
    <div className="ww-search">
      <span className="ww-search__icon" aria-hidden="true">
        <svg width="15" height="15" viewBox="0 0 16 16" fill="none">
          <circle cx="7" cy="7" r="4.6" stroke="currentColor" strokeWidth="1.4" />
          <path d="M10.6 10.6 14 14" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
        </svg>
      </span>
      <input
        className="ww-search__input"
        type="search"
        value={value}
        placeholder={placeholder}
        aria-label="Search images"
        onChange={(event) => onChange(event.target.value)}
      />
      {value ? (
        <button className="ww-search__clear" type="button" aria-label="Clear search" onClick={() => onChange('')}>
          ×
        </button>
      ) : null}
      {trailing}
    </div>
  )
}
